import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#243487",
      d: "M5.625 21.486q-.975 0-1.662-.7a2.3 2.3 0 0 1-.688-1.675v-4.7h2.35v4.7H19.35v-4.7h2.35v4.7q0 .975-.7 1.675-.699.7-1.65.7zm6.875-5.55-5.725-5.7 1.7-1.675 2.85 2.875V2.51h2.35v8.925l2.85-2.875 1.7 1.675z"
    }, null, -1)
  ])))
}
export default { render: render }